import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  inject
} from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { User } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-users-grid',
  // Point the template url to the base grid url
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './users-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersGridComponent extends BaseGridComponent implements OnInit {
  protected override _cdr = inject(ChangeDetectorRef);

  constructor(
    private UserService: UserService,
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'User';
    this.rowModelType = 'serverSide';

    this.additionalQueryData = {
      attributes: ['id']
    };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.UserService.getUsersV2(queryObject),
          this.UserService.getUserCountV2(countQueryObject)
        ]).subscribe({
          next: ([Users, userCount]) => {
            const successObject: { rowData: User[]; rowCount: number } = {
              rowData: Users,
              rowCount: userCount
            };

            params.success(successObject);
            this._cdr.markForCheck();
          },
          error: (error) => {
            console.log(error);
            params.fail();
            this._cdr.markForCheck();
          }
        });
      }
    };
  }
}
